import { render } from "./SampleView.vue?vue&type=template&id=23b18f0a"
import script from "./SampleView.vue?vue&type=script&lang=js"
export * from "./SampleView.vue?vue&type=script&lang=js"

import "./SampleView.vue?vue&type=style&index=0&id=23b18f0a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__